import { render } from "./RecoverPasswordForm.vue?vue&type=template&id=7c8fea4b"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__